document.addEventListener("bogos:gifts-end", () => {
function initBogosGiftButtonHandler() {
document.addEventListener(
  "click",
  async (e) => {
    const btn = e.composedPath().find(el =>
      el?.classList?.contains("bogos-gift-add-btn")
    );
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const variantId = btn.dataset.variantId;
    const offerId = btn.dataset.offerId;

    btn.disabled = true;

    try {
      const ok = await FGSECOMAPP.helper.addGiftToCart(
        Number(variantId),
        1,
        String(offerId)
      );

      if (ok) {
          try {
    const res = await fetch("/cart?sections=cart,cart-count");
    const data = await res.json();

    const drawer = document.querySelector("cart-drawer");
    if (!drawer) {
      console.warn("Cart drawer element not found");
      return;
    }

    // Replace HTML for each section
    Object.keys(data).forEach((sectionId) => {
      const html = data[sectionId];
      const container = document.querySelector(`#${sectionId}`);

      if (container) {
        const parsed = new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(`#shopify-section-${sectionId}`);

        if (parsed) container.innerHTML = parsed.innerHTML;
      }
    });

    drawer.classList.add("active");
  } catch (err) {
    console.error("Error refreshing drawer:", err);
  }
  document.dispatchEvent(
  new CustomEvent("gift-added", {
    detail: {
      variantId,
      offerId
    }
  })
);

      } else {
        btn.innerText = "ERROR";
        btn.disabled = false;
      }
    } catch (err) {
      console.error(err);
      btn.innerText = "FAILED";
      btn.disabled = false;
    }
  },
  true
);

}


initBogosGiftButtonHandler();


});



function toggleBogosGiftSliderVisibility() {
  const container = document.querySelector("[data-bogos-gifts]");
  if (!container) return;

  const swiperEl = container.querySelector("[js-carousel]");
  const wrapper = swiperEl?.querySelector(".swiper-wrapper");
  if (!wrapper) return;

  
  const hasRealContent = wrapper.innerHTML.trim().length > 0;

  if (!hasRealContent) {
    if (swiperEl?.swiper) {
      swiperEl.swiper.destroy(true, true);
    }
    container.style.display = "none";
  } else {
    container.style.display = "grid";
  }
}


document.addEventListener("gift-added", () => {

  toggleBogosGiftSliderVisibility();

});

document.addEventListener("upsell:added", () => {
  setTimeout(() => {
    toggleBogosGiftSliderVisibility();
  }, 300);
});

document.addEventListener("cart-theme:updated", () => {
  setTimeout(() => {
    toggleBogosGiftSliderVisibility();
  }, 300);
});
document.addEventListener("added:cart", () => {
  setTimeout(() => {
    toggleBogosGiftSliderVisibility();
  }, 300);
});
document.addEventListener("main:cart-added", () => {
  setTimeout(() => {
    toggleBogosGiftSliderVisibility();
  }, 300);
});

document.addEventListener("drawer:subscription-changed", () => {
  setTimeout(() => {
    toggleBogosGiftSliderVisibility();
  }, 300);
});





